import { Box } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useLocalization } from '@/hooks/useLocalization';
import { changeTone } from '@/utils/changeTone';

interface NetWorthChangeValueProps {
  /** The signed number the colour and caret are read from. */
  value: number;
  /** The formatted text to show, or null when there is no value to show. */
  text: string | null;
  /** Legacy's up or down caret, which it drew on percentages only. */
  caret?: boolean;
}

/**
 * A dollar or percentage change, coloured by direction, with legacy's caret
 * when asked for. A missing value shows as a plain `—`: it has no direction.
 */
export default function NetWorthChangeValue({
  value,
  text,
  caret = false,
}: NetWorthChangeValueProps) {
  const { t } = useLocalization();
  if (text === null) {
    return <Box component='span'>{t('common.emdash', '—')}</Box>;
  }
  const Caret = value < 0 ? ArrowDropDownIcon : ArrowDropUpIcon;
  return (
    <Box
      component='span'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color: changeTone(value),
        fontWeight: 500,
      }}
    >
      {caret && value !== 0 ? (
        <Caret
          fontSize='small'
          aria-hidden
        />
      ) : null}
      {text}
    </Box>
  );
}
